<template>
    <div
        class="header pa-2"
        :class="{
            scroll: visible,
        }"
    >
        <div class="background-header"></div>
        <div class="row justify-space-between">
            <div>
                <DxButton
                    class="custom-btn-white-color"
                    icon="mdi mdi-bell-outline"
                />
                <!-- @click="$router.go(-1)" -->
            </div>
            <div>
                <img src="@/assets/images/Logo-SonPhat-Trang.png" alt="" />
            </div>
            <div>
                <DxButton
                    class="custom-btn-white-color"
                    icon="mdi mdi-account"
                    @click="$router.push('/Thong-Tin-Tai-Khoan')"
                />
            </div>
        </div>
        <div
            class="text-xs-center color-fff"
            v-if="!visible"
            style="position: relative; z-index: 1"
        >
            <div>Xin chào,</div>
            <div class="font-20 font-medium">
                {{
                    $Core.Auth.TokenParsed != null
                        ? $Core.Auth.TokenParsed.given_name ||
                          $Core.Auth.TokenParsed.name ||
                          $Core.Auth.TokenParsed.preferred_username ||
                          ""
                        : ""
                }}
            </div>
        </div>
    </div>
</template>

<script>
import { DxButton } from "devextreme-vue/";
export default {
    props: {
        visible: { type: Boolean, default: false },
    },
    data() {
        return;
    },
    components: {
        DxButton,
    },
};
</script>

<style scoped>
.header {
    position: fixed;
    z-index: 100;
    width: 100vw;
    height: 148px;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}
.header.scroll {
    height: 48px;
}
.header img {
    width: 148px;
    height: 32px;
}
::v-deep .custom-btn-white-color i.dx-icon {
    color: white;
}
.background-header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 148px;
    background: linear-gradient(#03a9f4, #f8f8f8);
}
</style>
